/* Icon-only light/dark switch — shared by CustomerShellHeader and CustomerTopBar. */

import { useTranslation } from 'react-i18next';
import { useTheme } from './ThemeProvider.js';
import {
  CUSTOMER_ACCOUNT_HEADER_THEME_SWITCH_CLASS,
  CUSTOMER_ACCOUNT_HEADER_THEME_SWITCH_THUMB_CLASS,
} from './customerTopBarStyles.js';

/** Icon-only light/dark switch — no Světlý/Tmavý labels in the header. */
export function AccountThemeToggle(): JSX.Element {
  const { t } = useTranslation('customer');
  const { effectiveTheme, setTheme } = useTheme();
  const isDark = effectiveTheme === 'dark';

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={t('account.settings.appearanceAriaLabel')}
      data-testid="account-theme-toggle"
      title={t('account.settings.appearanceAriaLabel')}
      onClick={() => {
        setTheme(isDark ? 'light' : 'dark');
      }}
      className={[
        CUSTOMER_ACCOUNT_HEADER_THEME_SWITCH_CLASS,
        isDark
          ? 'justify-end border-[var(--color-border)] bg-[var(--color-accent)]'
          : 'justify-start border-[var(--color-on-surface)] bg-[var(--color-on-surface)]',
      ].join(' ')}
    >
      <span
        aria-hidden="true"
        className={[
          CUSTOMER_ACCOUNT_HEADER_THEME_SWITCH_THUMB_CLASS,
          isDark ? 'bg-[var(--color-surface-muted)]' : 'bg-[var(--color-surface)]',
        ].join(' ')}
      />
    </button>
  );
}
